export const INPUT_GROUP_CLASS_NAME = 'pds-input-group';
export const INPUT_GROUP_ITEM_CLASS_NAME = 'pds-input-group-item';
export const INPUT_GROUP_ADDON_CLASS_NAME = 'pds-input-group-addon';
export const INPUT_GROUP_DIVIDER_CLASS_NAME = 'pds-input-group-divider';
